import React from 'react';
import Avatar from '../Avatar';

interface SingleProjectBlockProps {
  project: {
    id: number | string;
    icon: string | null;
    title: string;
    url?: string;
  };
  onClick: () => void;
}
const SingleProjectBlock: React.FC<SingleProjectBlockProps> = ({
  project,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="bg-gray-700 py-10 px-4 w-full rounded-lg text-gray-100 flex flex-col justify-center items-center cursor-pointer hover:bg-gray-750"
    >
      <Avatar img={project.icon} text={project.title} />
      <h3 className="mt-2 text-md font-medium">{project.title}</h3>
      {project.url && (
        <div className="bg-gray-800 rounded-full mt-3 h-8 w-full text-sm flex items-center justify-center px-2 overflow-hidden">
          <div className="truncate">{project.url}</div>
        </div>
      )}
    </div>
  );
};

export default SingleProjectBlock;
